import React, { useState } from 'react';
import { AppBar, IconButton, Menu, MenuItem, Avatar, Divider } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

import useAuth from '../../hooks/useAuth';

function Topbar({ handleDrawerToggle, handleDesktopDrawerToggle, desktopOpen }) {
  const drawerWidth = 240;
  const collapsedWidth = 65;
  const [anchorEl, setAnchorEl] = useState(null);
  const { logout } = useAuth();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      className="!bg-gradient-secondary !text-white"
      position="fixed"
      sx={{
        width: {
          xs: '100%',
          sm: desktopOpen ? `calc(100% - ${drawerWidth}px)` : `calc(100% - ${collapsedWidth}px)`,
        },
        ml: {
          xs: 0,
          sm: desktopOpen ? `${drawerWidth}px` : `${collapsedWidth}px`,
        },
        transition: 'width 0.3s, margin 0.3s',
      }}
    >
      <div className="flex justify-between items-center">
        <div>
          {/* Mobile menu button */}
          <IconButton
            color="inherit"
            onClick={handleDrawerToggle}
            sx={{
              display: { xs: 'flex', sm: 'none' },
            }}
          >
            <MenuRoundedIcon />
          </IconButton>

          {/* Desktop menu button */}
          <IconButton
            color="inherit"
            onClick={handleDesktopDrawerToggle}
            className="hover:!text-secondary !transition-all"
            sx={{
              display: { xs: 'none', sm: 'flex' },
              width: 48,
              height: 48,
              transform: desktopOpen ? 'rotate(0deg)' : 'rotate(90deg)',
              transition: 'transform 0.3s',
            }}
          >
            <MenuRoundedIcon />
          </IconButton>
        </div>

        <div className="flex items-center gap-2 py-2 px-4">
          {/* <IconButton
            color="inherit"
            className="hover:!text-secondary !transition-all"
          >
            <Badge badgeContent={4} color="error">
              <NotificationsNoneRoundedIcon />
            </Badge>
          </IconButton> */}
          <IconButton onClick={handleMenu} color="inherit">
            <Avatar sx={{ width: 32, height: 32, bgcolor: 'secondary.main' }}>A</Avatar>
          </IconButton>
        </div>

        {/* User Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className="[&_.MuiPaper-root]:!bg-gray-800 [&_.MuiPaper-root]:!text-white [&_.MuiPaper-root]:!min-w-40"
        >
          <MenuItem onClick={handleClose}>Profile</MenuItem>
          <MenuItem onClick={handleClose}>Settings</MenuItem>
          <Divider className="!border-white/20" />
          <MenuItem onClick={logout}>Logout</MenuItem>
        </Menu>
      </div>
    </AppBar>
  );
}

export default Topbar;
